module.exports = __webpack_public_path__ + "static/img/tsk.0790f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tsk.jpg
// module id = BNaA
// module chunks = 1